import { ITableTitle } from '../../../../types/table'

export const STitles: ITableTitle[] = [
    { type: 'header', slug: 'increment' },
    { type: 'header', slug: 'count'},
    { type: 'header', slug: 'operation' },
    { type: 'header', slug: 'created', sort: true },
    { type: 'header', slug: '' },
]
